import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ff7ba488")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.orders, (order) => {
    return (_openBlock(), _createBlock("div", {
      key: order.orderId,
      class: ['order p-a', {bear: order.type === 1}],
      style: {top: _ctx.fy(order.createPrice) + 'px'}
    }, null, 6))
  }), 128))
})